/**
 * Login/Register-Overlay für den "Anmelden/Registrieren"-Button im Kommentarformular
 */
import { safeSelect } from './utils.js';
import { getFocusableElements } from './a11y.js';
import { initUserLogin } from './user.js';

export function initLoginOverlay() {
	try {
		const overlay = document.getElementById('login-overlay');
		const trigger = safeSelect('.comment-form__login-trigger');

		// Account-Seiten-Instanz unabhängig davon initialisieren, ob das Overlay/der
		// Trigger auf dieser Seite existieren (z.B. auf /account/ selbst).
		initUserLogin({ suffix: '-register' });

		if (!overlay || !trigger) {
			return;
		}

		const closeButton = safeSelect('.login-overlay__close', overlay);
		const overlayCtl = initUserLogin({ suffix: '-modal' });

		function openOverlay() {
			overlay.setAttribute('aria-hidden', 'false');
			overlay.classList.add('site-overlay--is-open');
			trigger.setAttribute('aria-expanded', 'true');
			document.body.classList.add('body--login-overlay-open');
			overlayCtl?.reset?.();

			const focusable = getFocusableElements(overlay);
			if (focusable.length) {
				setTimeout(() => focusable[0].focus(), 100);
			}
		}

		function closeOverlay() {
			overlay.setAttribute('aria-hidden', 'true');
			overlay.classList.remove('site-overlay--is-open');
			trigger.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('body--login-overlay-open');
			trigger.focus();
		}

		trigger.addEventListener('click', function(e) {
			e.preventDefault();
			openOverlay();
		});

		if (closeButton) {
			closeButton.addEventListener('click', function(e) {
				e.preventDefault();
				closeOverlay();
			});
		}

		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' && overlay.classList.contains('site-overlay--is-open')) {
				closeOverlay();
			}
		});

		document.addEventListener('click', function(e) {
			if (
				overlay.classList.contains('site-overlay--is-open') &&
				!overlay.contains(e.target) &&
				!trigger.contains(e.target)
			) {
				closeOverlay();
			}
		});

		console.log('Login-Overlay initialisiert');
	} catch (error) {
		console.error('Fehler bei der Initialisierung des Login-Overlays:', error);
	}
}
